function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 152.407 108"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h152.407v108H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca"
    },
    d: "M60.412 25.697h31.5v56.606h-31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.208 306a35.938 35.938 0 0 1 13.75-28.303 36 36 0 1 0 0 56.606A35.938 35.938 0 0 1 382.208 306Z",
    transform: "translate(-319.796 -252)",
    style: {
      fill: "#b6b6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.203 306a35.999 35.999 0 0 1-58.245 28.303 36.005 36.005 0 0 0 0-56.606A35.999 35.999 0 0 1 454.203 306ZM450.769 328.308v-1.16h.467v-.235h-1.19v.236h.468v1.159Zm2.31 0v-1.398h-.364l-.42.962-.42-.962h-.365v1.398h.258v-1.054l.393.908h.267l.394-.91v1.056Z",
    transform: "translate(-319.796 -252)",
    style: {
      fill: "#dbdbdb"
    }
  }));
};
export default SvgMastercard;